var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup52(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.01,
    height: 78.03,
    viewBox: "0 0 101.01 78.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1252.99 -5347.97)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1254.499 5349.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.339,43.577A16.153,16.153,0,1,0,42.762,16.171a21.538,21.538,0,1,0-20.73,27.407",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    y1: 32.306,
    transform: "translate(38.186 38.193)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,11.5,16.269,22.269,27.038,11.5",
    transform: "translate(21.917 48.231)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,45A22.506,22.506,0,0,1,13.742,1.768,22.506,22.506,0,0,1,31.258,43.232,22.359,22.359,0,0,1,22.5,45Zm.915-31.387L16.006,25.32l.159,2.222h7.287v3.845H26.98V27.542h2.014V24.7H26.98V13.613H23.415ZM23.452,24.7h-3.93l3.7-5.872.232-.4V24.7Z",
    transform: "translate(1309 5381)",
    fill: "#761ccb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup52);
export default __webpack_public_path__ + "static/media/Group52.f4f6bb28.svg";
export { ForwardRef as ReactComponent };